"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = makeAuthActions;
function makeAuthActions(feathersClient, globalModels) {
  return {
    authenticate: function authenticate(store, data) {
      var commit = store.commit,
          state = store.state;


      commit("setAuthenticatePending");
      if (state.errorOnAuthenticate) {
        commit("clearAuthenticateError");
      }

      var promise = !!data ? feathersClient.authenticate(data) : feathersClient.reAuthenticate();
      return promise.then(function (response) {
        if (response.accessToken) {
          commit("setAccessToken", response.accessToken);
          commit("setPayload", response);
          commit("setUser", response.user);
          commit("unsetAuthenticatePending");

          // If there was not an accessToken in the response, allow the response to pass through to handle two-factor-auth
        } else {
          return response;
        }
      }).catch(function (error) {
        commit("setAuthenticateError", error);
        commit("unsetAuthenticatePending");
        return Promise.reject(error);
      });
    },
    logout: function logout(_ref) {
      var commit = _ref.commit;

      commit("setLogoutPending");
      return feathersClient.logout().then(function (response) {
        commit("logout");
        commit("unsetLogoutPending");
        return response;
      }).catch(function (error) {
        return Promise.reject(error);
      });
    }
  };
}
module.exports = exports.default;